import { supabase } from "../../lib/supabaseClient";

function requireClient() {
  if (!supabase) throw new Error("Supabase is not configured.");
  return supabase;
}

function utcDayStartIso() {
  const d = new Date();
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())).toISOString();
}

async function countRows(table, { since = null } = {}) {
  let query = requireClient().from(table).select("*", { count: "exact", head: true });
  if (since) query = query.gte("created_at", since);
  const { count, error } = await query;
  if (error) throw error;
  return count ?? 0;
}

/**
 * App-wide activity counters for Admin Overview.
 * likes = likes sent, messages = messages sent, matches = mutual matches created.
 */
export async function GetAdminActivityStats() {
  const since = utcDayStartIso();
  const [likesTotal, likesToday, messagesTotal, messagesToday, matchesTotal, matchesToday] =
    await Promise.all([
      countRows("likes"),
      countRows("likes", { since }),
      countRows("messages"),
      countRows("messages", { since }),
      countRows("matches"),
      countRows("matches", { since }),
    ]);

  return {
    likesTotal,
    likesToday,
    messagesTotal,
    messagesToday,
    matchesTotal,
    matchesToday,
  };
}
